import { DEFAULT_MAP_SOURCE } from '@env';

import { ComponentRef, Optional, Type } from '@angular/core';

import { IFsMap } from '@lib/geo/core';
import { GoogleMap } from '@lib/geo/google/map';
import { Evented } from '@lib/geo/helpers';

import { MapPopupService } from '../../services';
import { FsMap } from '../../types';
import { IFsMapPopupEvents } from './popup-events';
import { IFsMapPopupOptions } from './popup-options';

const DEFAULT_OPTIONS: IFsMapPopupOptions = {
  disableAutoPan: false,
};

export class FsMapPopup<TMap extends IFsMap, T = any> extends Evented<IFsMapPopupEvents> {
  private readonly data: IFsMapPopupOptions<T>;
  private readonly _options: IFsMapPopupOptions;
  private readonly _component: Type<any>;
  private readonly _map: TMap;

  private popupService: MapPopupService<TMap>;
  private _element: HTMLElement;
  private _componentRef: ComponentRef<any>;

  get defaultMapSource(): string {
    return DEFAULT_MAP_SOURCE;
  }

  get componentInstance(): any {
    return this._componentRef.instance;
  }

  constructor(
    popupService: MapPopupService<TMap>,
    map: TMap,
    component: Type<any>,
    @Optional() options?: IFsMapPopupOptions,
  ) {
    super();

    this.popupService = popupService;
    this._map = map;
    this.data = options;
    this._options = { ...DEFAULT_OPTIONS, ...options };
    this._component = component;
    if (this._options.lonLat) {
      this._updatePosition();
    }
  }

  public open(): void {
    const { componentRef, domElem } = this.popupService.createPopupComponent(
      this._component,
      this._options,
    );
    this._componentRef = componentRef;
    this._element = domElem;
    if (this._componentRef.instance.close$) {
      this._componentRef.instance.close$.subscribe(() => {
        this.close();
      });
    }

    this.popupService.openPopup(this._element, this.data, this._map);
  }

  public getData(): T {
    return this.data.data;
  }

  public close(): void {
    this.popupService.closePopup();
  }

  private _updatePosition(): void {}
}
